import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { Checkbox, FormControlLabel, Grid } from '@mui/material'
import React from 'react'
import { PIFormSection } from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingsPageStyles'
import CommunicationReceiver from './CommunicationReceiver'

export const PatientCommunicationToPref = ({
  communicationToPref = {},
  onPreferenceChange,
  onAddReceiver,
  onUpdateReceiver,
  onRemoveReceiver,
  editMode = true,
  validationHook,
}) => {
  const {
    toPatient = true,
    toAttendant = true,
    toOthers = true,
    receivers = [],
  } = communicationToPref || {}

  return (
    <>
      {/* Boolean Preferences Section */}
      <PIFormSection size={{ xs: 12 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={toPatient}
                  onChange={(e) => {
                    if (editMode && onPreferenceChange) {
                      onPreferenceChange('toPatient', e.target.checked)
                    }
                  }}
                  disabled={!editMode}
                  size="small"
                />
              }
              label="Send to Patient"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={toAttendant}
                  onChange={(e) => {
                    if (editMode && onPreferenceChange) {
                      onPreferenceChange('toAttendant', e.target.checked)
                    }
                  }}
                  disabled={!editMode}
                  size="small"
                />
              }
              label="Send to Attendant"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={toOthers}
                  onChange={(e) => {
                    if (editMode && onPreferenceChange) {
                      onPreferenceChange('toOthers', e.target.checked)
                    }
                  }}
                  disabled={!editMode}
                  size="small"
                />
              }
              label="Send to Others"
            />
          </Grid>
        </Grid>
      </PIFormSection>

      {/* Additional Recipients Section */}
      {toOthers && (
        <PIFormSection size={{ xs: 12 }}>
          <div className="d-flex flex-column">
            <div className="d-flex align-items-center gap-2 mb-3">
              <h6 className="mb-0">Additional Recipients</h6>
              {editMode && onAddReceiver && (
                <AddCircleOutlineIcon
                  style={{ cursor: 'pointer', fontSize: '20px' }}
                  onClick={onAddReceiver}
                />
              )}
            </div>

            {receivers.length === 0 && (
              <p className="text-muted mb-2" style={{ fontSize: '14px' }}>
                No additional recipients added. {editMode && 'Click + to add recipients.'}
              </p>
            )}

            {receivers.map((receiver, index) => (
              <CommunicationReceiver
                key={index}
                receiver={receiver}
                index={index}
                onUpdate={onUpdateReceiver}
                onRemove={onRemoveReceiver}
                editMode={editMode}
                validationHook={validationHook}
              />
            ))}
          </div>
        </PIFormSection>
      )}
    </>
  )
}

export default PatientCommunicationToPref
